var React = require('react');

function Filter (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"SEARCH"),React.createElement("g",{"id":"propuesta-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"SUBGATEGORÍA-TEQUILA","transform":"translate(-1002.000000, -214.000000)","stroke":"#E85633","strokeWidth":"2"},React.createElement("g",{"id":"SEARCH","transform":"translate(1004.000000, 214.000000)"},React.createElement("polygon",{"id":"Path","points":"0.702008232 1.36051306 15.3510573 1.35369299 9.34464476 9.35093608 9.35873357 13.9990766 6.67943549 15.365425 6.65305261 9.32706585"}))))]);
}

Filter.defaultProps = {"width":"20px","height":"17px","viewBox":"0 0 20 17","version":"1.1"};

module.exports = Filter;

Filter.default = Filter;
